import React, { Component } from 'react';

import PaperContainer from '../../common-components/PaperContainer';
import Page from '../../common-components/Page';
import Grid from '@material-ui/core/Grid';
// import Typography from '@material-ui/core/Typography';

import DMYGraphFilterForm from './DMYGraphFilterForm';
import DMYGraphFilterFieldForm from './DMYGraphFilterFieldForm';
import DMYLineGraph from './DMYLineGraph';

import * as strings from '../../helpers/strings';

class DMYLineGraphScreen extends Component {

  render() {
    return (
      <Page title={strings.lblStationRealtimeData} >
        {/* <Typography variant="h5" color={strings.colorPrimary} title={strings.lblStationRealtimeChart}>{strings.lblStationRealtimeChart}</Typography> */}
          <Grid container spacing={16}>
            <Grid item md={3} xs={12}>
              <DMYGraphFilterForm />
              <DMYGraphFilterFieldForm />
            </Grid>
            <Grid item md={9} xs={12}>
              <DMYLineGraph />
            </Grid>
          </Grid>
      </Page>
    )
  }
}

export default DMYLineGraphScreen